module.exports = __webpack_public_path__ + "static/media/Tischlaeufer_45x250.bbe42d9a.png";